import Box from "@galaxy-io/dls/layout/Box";
import Tabs from "@galaxy-io/dls/navigation/Tabs";
import type { UserPreferences } from "@gtm/contracts/core/preferences";
import { usePathname, useRouter, useSearchParams } from "@/app/navigation";
export function SignalsView({ view }: { view: UserPreferences["signalsView"] }) {
  const router = useRouter(),
    path = usePathname(),
    search = useSearchParams();
  return (
    <Box padding={[0, 12]}>
      <Tabs
        ariaLabel="Signals view"
        value={view}
        onChange={(value) => {
          const params = new URLSearchParams(search);
          params.set("view", value);
          params.delete("page");
          router.push(`${path}?${params}`);
        }}
        items={[
          { id: "board", label: "Board" },
          { id: "table", label: "Table" },
          { id: "swipe", label: "Swipe" },
        ]}
      />
    </Box>
  );
}
